"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const stores_1 = require("modules/content/dripping/stores");
const types_1 = require("modules/content/dripping/types");
class DrippingFormConvert {
    constructor() {
        this.getDrippingFromStore = () => {
            const newDripping = {
                id: stores_1.DrippingFormStore.drippingId,
                key: stores_1.DrippingFormStore.key,
                allClasses: stores_1.DrippingFormStore.classType === types_1.ClassTypes.All,
                classes: this.getClasses(),
                releaseDays: this.getReleaseNumberOfDays(),
                releaseDate: this.getReleaseDate(),
                expirationDays: this.getExpirationNumberOfDays(),
                pageId: stores_1.DrippingFormStore.quizId,
                isUpdated: Boolean(stores_1.DrippingFormStore.drippingId)
            };
            return newDripping;
        };
        this.getReleaseNumberOfDays = () => {
            if (stores_1.DrippingFormStore.isReleaseEnabled &&
                stores_1.DrippingFormStore.releaseDrippingType === types_1.ReleaseDrippingTypes.DaysAfter) {
                return stores_1.DrippingFormStore.releaseNumberOfDays;
            }
            return null;
        };
        this.getReleaseDate = () => {
            const dateTimeValue = stores_1.DrippingFormStore.releaseDateTimeISO;
            if (stores_1.DrippingFormStore.isReleaseEnabled &&
                stores_1.DrippingFormStore.releaseDrippingType ===
                    types_1.ReleaseDrippingTypes.SpecificDate &&
                dateTimeValue) {
                return new Date(dateTimeValue).toISOString();
            }
            return null;
        };
        this.getExpirationNumberOfDays = () => {
            if (stores_1.DrippingFormStore.isExpirationEnabled) {
                return stores_1.DrippingFormStore.expirationNumberOfDays;
            }
            return null;
        };
        this.getClasses = () => {
            if (stores_1.DrippingFormStore.classType === types_1.ClassTypes.Specific) {
                return stores_1.DrippingFormStore.selectedClasses.map(({ id: hashId, name, defaultClass }) => ({
                    hashId,
                    name,
                    defaultClass
                }));
            }
            return [];
        };
    }
}
exports.default = new DrippingFormConvert();
